module.exports = __webpack_public_path__ + "static/media/show-and-hide-layer.b68524e5.gif";